module.exports = __webpack_public_path__ + "fonts/Inter-Light.b9920de.woff";